import { Datagrid, List, TextField } from "react-admin";
import { useGlobalPermission } from "../../permissions";

export const OrganList = () => (
	<List hasCreate={useGlobalPermission("organs.create")}>
		<Datagrid bulkActionButtons={false} rowClick="show">
			<TextField source="name" />
		</Datagrid>
	</List>
);
